@if (isEditingSg()) {
  <atn-ds-slideout-overlay
    [name]="titleSg()"
    [hasFullHeight]="false"
  >
    <i
      actions
      class="atn-icon atn-close atn-red"
      (click)="closeBtnClickHandler()"
    ></i>

    <div class="rule-slideout">
      <div class="rule-slideout__tabs">
        <atn-ds-integrated-horizontal-tabs>
          <ng-template
            atnDsTab
            name="Conditions"
            ><atn-conditions-tab
          /></ng-template>
          <ng-template
            atnDsTab
            name="Adjustment"
          >
            <atn-adjustment-tab />
          </ng-template>
        </atn-ds-integrated-horizontal-tabs>
      </div>
      <!-- ------------------------------- Footer -------------------------------- -->
      <div class="rule-slideout__footer">
        <atn-ds-button
          class="rule-slideout__footer-test-btn"
          [type]="PredefinedStyleEnum.Transparent"
          (click)="testBtnClickHandler()"
          >Test</atn-ds-button
        >

        <atn-ds-button
          class="rule-slideout__footer-cancel-btn"
          [type]="PredefinedStyleEnum.Transparent"
          (click)="cancelBtnClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button (click)="submitBtnClickHandler()">{{
          submitButtonLabelSg()
        }}</atn-ds-button>
      </div>
    </div>
  </atn-ds-slideout-overlay>
}
